import {
  connectLoginSocket,
  disconnectLoginSocket
} from 'components/ReusableComponents/LoginSocket'
import dashboardApi from 'services/api/dashboard'
import LocalUserService from 'services/localUserService'
import {
  startMagicLinkLoginPolling,
  stopMagicLinkLoginPolling
} from 'services/helpers/magicLinkLoginPolling'

const userService = new LocalUserService()

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit')

const initialState = {
  isLoginRequestSent: false,
  loginStep: 'loginForm',
  loginType: null,
  error: null,
  socketConnected: false,
  pendingSessionId: null,
  qrCode: null,
  geoLocation: { latitude: 0, longitude: 0 },
  hasPWA: true
}

export const postLoginInfo = createAsyncThunk(
  'signIn/beginLogin',
  async ({ email, phone, geoLocation }, { dispatch }) => {
    userService.removeCurrentUser()

    const res = await dashboardApi.loginBegin({
      email,
      phone,
      geoLocation,
      screen: `${window.screen.width}x${window.screen.height}`
    })

    if (res) {
      connectLoginSocket(dispatch, res.sessionId)
      startMagicLinkLoginPolling(dispatch, res.sessionId)
    }

    return res
  }
)

export const resetForm = createAsyncThunk('signIn/resetForm', async () => {
  stopMagicLinkLoginPolling()
  disconnectLoginSocket()
})

const signInSlice = createSlice({
  name: 'signIn',
  initialState,
  reducers: {
    hasPWA: (state, action) => {
      state.hasPWA = action.payload
    },
    resetForm: state => {
      return { ...initialState, qrCode: state.qrCode }
    },
    saveGeoLocation: (state, action) => {
      state.geoLocation = action.payload
    }
  },
  extraReducers: {
    WS_DISCONNECTED: (state, action) => {
      if (
        state.loginStep === 'sentRequest' ||
        state.loginStep === 'sentRequestAndOpenedSocket'
      ) {
        return {
          ...state,
          socketConnected: false
        }
      }

      return { ...state, socketConnected: false }
    },
    WS_CONNECTED: state => {
      if (state.loginStep === 'sentRequest') {
        state.loginStep = 'sentRequestAndOpenedSocket'
      }

      state.socketConnected = true
    },

    [resetForm.fulfilled]: () => {
      return { ...initialState }
    },
    USER_LOGGED_IN: state => {
      stopMagicLinkLoginPolling()
      return { ...initialState, geoLocation: state.geoLocation, hasPWA: state.hasPWA }
    },
    [postLoginInfo.pending]: (state, action) => {
      if (action.meta.arg.email) {
        state.loginType = 'email'
      }

      if (action.meta.arg.phone) {
        state.loginType = 'phone'
      }

      state.loginStep = 'pendingSendRequest'
      state.error = null
    },
    [postLoginInfo.rejected]: (state, action) => {
      if (action.error.message === 'User not found' && state.loginType === 'email') {
        state.error =
          "Couldn't find your account. Make sure your email is typed correctly and try again."
      } else if (
        action.error.message === 'User not found' &&
        state.loginType === 'phone'
      ) {
        state.error =
          "Couldn't find your account. Make sure your phone number is typed correctly and try again."
      } else {
        state.error = 'Something went wrong, please try again.'
      }

      state.isPendingSendingRequest = false
      state.loginStep = 'loginForm'
    },
    [postLoginInfo.fulfilled]: (state, action) => {
      state.isPendingSendingRequest = false
      state.loginStep = 'sentRequest'
      state.pendingSessionId = action.payload?.sessionId || null
    }
  }
})

export default signInSlice
